import { ReactElement, useEffect, useState } from 'react'
import { PracticeWrapper, SubjectGroupWrapper } from './subcomponents'
import ScheduledTests from '../Assessment/ScheduledTests'
import AttemptedTests from '../Assessment/AttemptedTests/updateindex'
import { FlexWrapper, SectionTitle, SubHeader } from '../../../components'
import SubjectGroup from './SubjectGroup'
import strings from '../../../locale/en'
import { getSubjectLogo } from '../../../helpers'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../redux/store'
import { getScheuledTests, getAttemptedTests } from '../../../redux/test/action'

const PracticeTest = (): ReactElement => {
  const {
    selectedBatch = '',
    studentId = '',
    practiceTestList = [],
    attemptedTests = []
  } = useSelector(
    (state: RootState) => ({
      selectedBatch: state.user.selectedBatch,
      studentId: state.user?.userInfo?.userDetail?.usersId,
      practiceTestList: state.test?.practiceTests,
      attemptedTests: state.test?.attemptedPracticeTests
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const subjects = practiceTestList.map((test) => test?.courseName)
  const [subject, setSubject] = useState('')
  const scheduledTestList = practiceTestList.filter(
    (test) => test?.courseName === subject
  )
  const {
    assessment: { scheduledTests }
  } = strings

  const practiceTests = (
    <>
      <SubHeader
        title={subject}
        logo={getSubjectLogo({
          subject: subject
        })}
        handleBack={() => {
          setSubject('')
        }}
      />
      <ScheduledTests scheduledTests={scheduledTestList} isPractice />
    </>
  )

  const subjectGroup = (
    <SubjectGroupWrapper>
      <SectionTitle title={scheduledTests} />
      <FlexWrapper noPadding justifyContent="space-between">
        {subjects.map((subject, index) => (
          <SubjectGroup
            subjectName={subject ? subject.toLocaleLowerCase() : ''}
            handleSelect={() => setSubject(subject)}
            key={`subject=${index}`}
          />
        ))}
      </FlexWrapper>
      <AttemptedTests attemptedTests={attemptedTests} />
    </SubjectGroupWrapper>
  )

  useEffect(() => {
    if (selectedBatch) {
      dispatch(
        getScheuledTests({ batchId: selectedBatch, studentId: studentId })
      )
      dispatch(
        getAttemptedTests({ batchId: selectedBatch, studentId: studentId })
      )
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBatch])

  return (
    <PracticeWrapper id="container">
      {subject ? practiceTests : subjectGroup}
    </PracticeWrapper>
  )
}

export default PracticeTest
